import { AppState } from 'domains/contracts/appState'
import { ModalController } from '..'

export interface ModalViewModel {
  controllers: ModalController[]
}
export default (state: AppState): ModalViewModel => ({
  controllers: state.common.modalComponents as ModalController[],
})
